import _ from "lodash";
import vm from "../main";
import { httpClient as http } from "../services";

const internals = {};

internals.addDailyWages = (dailyWages) => {
  dailyWages = Object.assign({}, dailyWages);
  const promises = [];
  return http
    .post("/daily-wages/create", {
      cityId: dailyWages.cityId,
      expense: dailyWages.expense,
      expenseDate: dailyWages.expenseDate,
      expenseType: dailyWages.expenseType,
      amount: dailyWages.amount,
      receipt: dailyWages.receipt.toString(),
    })
    .then((result) => {
      dailyWages = result.data;
      return Promise.all(promises);
    })
    .catch((error) => {
      console.error("dailyWages.create-error:\n", error);
      throw error;
    });
};

internals.updateDailyWages = (_id, dailyWages) => {
  return http
    .put(`/daily-wages/update`, {
      cityId:dailyWages.cityId,
      expense: dailyWages.expense,
      expenseDate: dailyWages.expenseDate,
      expenseType: dailyWages.expenseType,
      amount: dailyWages.amount,
      receipt: dailyWages.receipt.toString(),

      _id: dailyWages._id,
    })
    .then((result) => {
      dailyWages = result.data;
      return dailyWages;
    })
    .catch((error) => {
      console.error("dailyWages.updateVehicle-error:\n", error);
      throw error;
    });
};

internals.deleteDailyWages = (_id) => {
  return http
    .delete(`/daily-wages/delete?_id=` + _id)
    .then((result) => {
      return result;
    })
    .catch((error) => {
      console.error("dailyWages.delete-error:\n", error);
      throw error;
    });
};

internals.getById = (Id) => {
  return http
    .get(`daily-wages/getById?_id=${Id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("dailyWages-error:\n", error);
      throw error;
    });
};

export default internals;



// WEBPACK FOOTER //
// ./src/services/dailywages.service.js